module.exports = ".error{\r\n    border: 1px solid red;\r\n  }"